import CompanyRoutes from "../../apiRoutes/CompanyRoutes";
import { GET, POST } from "../ConsumeApiController";

export async function getAll()
{
    const response = await GET(CompanyRoutes.Reviews.GetAll);
    return response;
}
